import React from 'react'

import InfoFeatures from '../../components/Info/Features'
import Feature from '../../components/Feature'
import cloudDocs from './cloud-docs.svg'
import education from './education.svg'
import steppingUp from './stepping-up.svg'

const Features = () => {
  return (
    <InfoFeatures title="Lesson Focus Areas">
      <Feature
        title="Computational Thinking Fundamentals"
        src={steppingUp}
        alt="A person stepping up an ascending bar chart."
      >
        Fundamentals are very imporantant. Learning becomes easy with good
        fundamentals
      </Feature>
      <Feature
        title="Exam Answering Techniques"
        src={education}
        alt="A woman holding a graduation cap and standing on two books."
      >
        Learn the the tips & tricks to best present your answers in exams
      </Feature>
      <Feature
        title="Practice on Relevant Questions"
        src={cloudDocs}
        alt="A person looking towards a spiral of 3 questions."
      >
        Attempt questions that is useful for learning and exams practices
      </Feature>
    </InfoFeatures>
  )
}

export default Features
